import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

export const initDatadogRum = () => {
  if (!import.meta.env.PROD) {
    return;
  }

  datadogRum.init({
    applicationId: 'ca07b174-6584-4264-bd22-d216ee17625e',
    clientToken: 'pub752d3b66ef86d7ecc361a20496c9ec55',
    site: 'us5.datadoghq.com',
    service: 'maia-frontend',
    env: import.meta.env.VITE_DATADOG_ENV || import.meta.env.MODE,
    version: __APP_VERSION__, // injected from package.json at build time (vite.config.ts)
    sessionPersistence: 'local-storage',
    sessionSampleRate: 100, // capture 100% of sessions
    sessionReplaySampleRate: 100, // capture 100% of sessions with replay
    trackResources: true, // Enable Resource tracking
    trackUserInteractions: true, // Enable Action tracking
    trackLongTasks: true, // Enable Long Tasks tracking

    // ----- Recommended Options -----
    // allowedTracingUrls: '<BACKEND_URL>',     // Enable distributed tracing
    // defaultPrivacyLevel: 'mask-user-input',  // 'mask-user-input' | 'allow' | 'mask'
    plugins: [reactPlugin({ router: true })],
  });
};
